module.exports = __webpack_public_path__ + "img/pc-phone-placeholder.d90b8bb3.webp";